import { render } from "./LifetimeStatsChart.vue?vue&type=template&id=37f5d28b"
import script from "./LifetimeStatsChart.vue?vue&type=script&lang=js"
export * from "./LifetimeStatsChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__